import produce from 'immer'
import { AnalyticsActionTypes, getAllEventsActionType, getCallEventsActionType, getTargetedEventsActionType } from "../../model/analytics/actions";
import { AnalyticsState } from "../../model/analytics/types";

const initialCallPerfState = {
    incidentNumber: 0,
    callNumber: 0,
    clusters: [],
    statistics: [],
}

const initialState: AnalyticsState  = {
    events: [],
    eventPerf: initialCallPerfState,
    globalPerf: initialCallPerfState
}

export function analyticsReducer(
  state = initialState,
  action: AnalyticsActionTypes
): AnalyticsState {
  switch (action.type) {
    case getAllEventsActionType.success:
      return produce(state, draftState => {
        draftState.globalPerf = action.payload 
      });

    case getAllEventsActionType.failure:
      return produce(state, draftState => {
        draftState .globalPerf = initialState.globalPerf       
      });

    case getCallEventsActionType.success:
      return produce(state, draftState => {
        draftState.events = action.payload
      });

    case getCallEventsActionType.failure:
      return produce(state, draftState => {
         draftState.events = initialState.events   
      });

    case getTargetedEventsActionType.success:
      return produce(state, draftState => {
        draftState.eventPerf = action.payload 
      });

    case getTargetedEventsActionType.failure:
      return produce(state, draftState => {
        draftState.eventPerf = initialState.eventPerf
      });

    default:
      return state
    }
}